module.exports = __webpack_public_path__ + "img/light_online.37619a2e.png";